export enum AlertSeverity {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
}
